
import { IServiceMap } from '@/business/BusinessFormData'
import { IOrderForm } from '@/types/placeOrderTypes'
import { Component, Vue } from 'vue-property-decorator'
import BasePage from '../BasePage.vue'
import BasicInfo from '../components/BasicInfo.vue'
import UploadMaterial from '../components/Upload/UploadMaterial.vue'
import _ from 'lodash'
import { Getter } from 'vuex-class'
import { IFormMap } from '@/store/modules/formMap'
import { getDefaultForm } from '../helper'
import { ICustomerAppKey, IOrganization } from '@/store/state'
import { ServiceContentEnum } from '@/business/ServiceContent'

@Component({
  components: {
    BasePage,
    BasicInfo,
    UploadMaterial,
  },
})
export default class PlaceOrder extends Vue {
  @Getter('order_id') order_id!: string
  @Getter('customerAppKey') customerAppKey!: ICustomerAppKey
  @Getter('organization') organization!: IOrganization
  @Getter('formMap')
  formMap!: IFormMap

  defaultForm: IOrderForm = {} as IOrderForm
  form: IOrderForm = {} as IOrderForm
  formInfo: null | IServiceMap = null
  regBookName = false

  type = ''
  name = ''
  reEdit = false

  BaseMounted(serviceType: string, name: string) {
    this.type = serviceType
    this.name = name
    this.formInfo = this.formMap.formMap![serviceType]
    this.defaultForm = getDefaultForm(serviceType, this.formInfo, this.organization, this.customerAppKey, name)
  }

  FormChange(form: IOrderForm) {
    this.form = form
  }

  creatCheckForm(form: IOrderForm) {
    if (!form.book_name) return this.$message.error('请输入图书名称')
    if (!form.alias) return this.$message.error('请输入工单别名')
    if (!form.subject) return this.$message.error('请选择学科')
    if (!form.stage) return this.$message.error('请选择学段')
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.book_name)) {
      this.regBookName = true
      return this.$message.error('图书名称含有非法字符')
    }
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.alias)) {
      return this.$message.error('工单别名含有非法字符')
    }
  }

  submitCheckForm(bounds: any, callback: (val: boolean) => void) {
    // 文件检查
    if ((this.$children[2] as any)?.files.some((item: any) => item.ZIPinZIPList.length)) {
      this.$message.error('请移除无效压缩包')
      return callback(true)
    }
    if (!this.form.material.oss_zip_files?.length) {
      this.$message.error('请上传ppt压缩包')
      return callback(true)
    }

    return callback(false)
  }

  async submit(formData: any) {
    formData.xdoc_planning.push({
      config: { ppt2seewo_config: { ...this.form.config }, delivery: 20 },
      origin_files: [...this.form.material.oss_zip_files],
    })
    if (!formData.book_name) {
      formData.book_name = formData.material.oss_zip_files?.[0].name.replace('.zip', '')
      formData.alias = formData.material.oss_zip_files?.[0].name.replace('.zip', '')
      formData.xdoc_planning.forEach((item: any) => (item.name = formData.book_name))
    }
    delete formData.config
  }

  screenForm(form: any) {
    const keys = Object.keys(form)
    const defaultKeys = Object.keys(this.defaultForm)
    const screenkeys = keys.filter(item => defaultKeys.includes(item))
    const screenForm: any = {}
    screenkeys.forEach(item => {
      screenForm[item] = form[item]
    })
    return screenForm
  }
}
